"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryWebhookEventType = exports.StorefrontWebhookEventType = exports.MenuWebhookEventType = exports.OrderWebhookEventType = void 0;
var OrderWebhookEventType;
(function (OrderWebhookEventType) {
    OrderWebhookEventType["NewOrder"] = "orders.new_order";
    OrderWebhookEventType["StatusUpdate"] = "orders.order_status_update";
    OrderWebhookEventType["CancelOrder"] = "orders.cancel_order";
})(OrderWebhookEventType = exports.OrderWebhookEventType || (exports.OrderWebhookEventType = {}));
var MenuWebhookEventType;
(function (MenuWebhookEventType) {
    MenuWebhookEventType["PublishMenu"] = "menus.menu_publish";
    MenuWebhookEventType["UpdateMenu"] = "menus.update_menu_entities_availabilities";
    MenuWebhookEventType["SendMenu"] = "menus.send_menu";
    MenuWebhookEventType["UpsertHours"] = "menus.upsert_hours";
})(MenuWebhookEventType = exports.MenuWebhookEventType || (exports.MenuWebhookEventType = {}));
var StorefrontWebhookEventType;
(function (StorefrontWebhookEventType) {
    StorefrontWebhookEventType["GetStoreAvailability"] = "storefront.get_store_availability";
    StorefrontWebhookEventType["PauseStore"] = "storefront.pause_store";
    StorefrontWebhookEventType["UnpauseStore"] = "storefront.unpause_store";
    StorefrontWebhookEventType["GetStoreHours"] = "storefront.get_store_hours";
})(StorefrontWebhookEventType = exports.StorefrontWebhookEventType || (exports.StorefrontWebhookEventType = {}));
var DeliveryWebhookEventType;
(function (DeliveryWebhookEventType) {
    DeliveryWebhookEventType["RequestQuote"] = "delivery.request_quote";
    DeliveryWebhookEventType["Accept"] = "delivery.accept";
    DeliveryWebhookEventType["Cancel"] = "delivery.cancel";
})(DeliveryWebhookEventType = exports.DeliveryWebhookEventType || (exports.DeliveryWebhookEventType = {}));
